var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Edit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.546L12.929 14.546M5.205 10.985l-4 1.143 1.143-4L10.062.414c.552-.552 1.448-.552 2 0l.857.857c.552.553.552 1.448 0 2l-7.714 7.714zM11.776 4.414L8.919 1.557",
    transform: "translate(-412 -175) translate(412 175) translate(1.333 .667)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Edit);
export default __webpack_public_path__ + "static/media/ico16Edit.9510ea0a.svg";
export { ForwardRef as ReactComponent };